module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerut0a01",
      "epub:type": "division",
      "id": "ut0a"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerut0a01"
    }
  }, [_c('h1', {
    staticClass: "ut"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "2",
      "id": "p2",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "3",
      "id": "p3",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20005#toc"
    }
  }, [_vm._v("A. Drafting")])])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p3"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20009#ut0a-intro"
    }
  }, [_vm._v("Introduction to Part 1A")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20010#thirtyninth"
    }
  }, [_vm._v("The Thirty-Ninth Congress: Membership")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20011#ut0a-ch01"
    }
  }, [_vm._v("1. US Senate, Opening Day of Thirty-Ninth Congress (Dec. 4, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20012#ut0a-ch02"
    }
  }, [_vm._v("2. US House, Opening Day of Thirty-Ninth Congress, Exclusion of Former Rebel States, Appointing Joint Committee on Reconstruction (Dec. 4, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20013#ut0a-ch03"
    }
  }, [_vm._v("3. US House, Thaddeus Stevens, Proposed Amendments (Dec. 5, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20014#ut0a-ch04"
    }
  }, [_vm._v("4. US House, John Bingham, Proposed Amendment (Dec. 6, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20015#ut0a-ch05"
    }
  }, [_vm._v("5. US Senate, Appointing Joint Committee on Reconstruction (Dec. 12, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20016#ut0a-ch06"
    }
  }, [_vm._v("6. Joint Committee on Reconstruction, Membership (1865–1867)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20017#ut0a-ch07"
    }
  }, [_vm._v("7. US Senate, Freedmen’s Bureau Bill, Black Codes (Dec. 13, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20018#ut0a-ch08"
    }
  }, [_vm._v("8. Secretary of State William Seward, Proclamation of Ratification of the Thirteenth Amendment (Dec. 18, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20019#ut0a-ch09"
    }
  }, [_vm._v("9. US Senate, Lyman Trumbull, Freedmen’s Bureau Bill (Dec. 19, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20020#ut0a-ch10"
    }
  }, [_vm._v("10. US House, Passage of Proposed Amendment on the Rebel Debt (Dec. 19, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20021#ut0a-ch11"
    }
  }, [_vm._v("11. Elizabeth Cady Stanton, “This Is the Negro’s Hour,” "), _c('i', [_vm._v("National Anti-Slavery Standard")]), _vm._v(" (Dec. 30, 1865)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20022#ut0a-ch12"
    }
  }, [_vm._v("12. US House, James G. Blaine, Proposed Suffrage-Based Apportionment Amendment (Jan. 8, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20023#ut0a-ch13"
    }
  }, [_vm._v("13. Joint Committee, Proposed Apportionment Amendment, Exclusion of “Insurgent States” (Jan. 9, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20024#ut0a-ch14"
    }
  }, [_vm._v("14. US House, John Bingham, Proposed Amendment to Grant Congress Power to Secure “Equal Personal Rights” (Jan. 9, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20025#ut0a-ch15"
    }
  }, [_vm._v("15. US Senate, Lyman Trumbull, Judiciary Committee Reports S. Nos. 60 & 61 (Freedmen’s Bureau and Civil Rights Bills) (Jan. 11, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20026#ut0a-ch16"
    }
  }, [_vm._v("16. US Senate, Lyman Trumbull, Reporting Amendments to Civil Rights Bill (Jan. 12, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20027#ut0a-ch17"
    }
  }, [_vm._v("17. Joint Committee, Proposed Amendments, Apportionment, Power to Secure to All Persons “Equal Protection in Their Rights of Life, Liberty and Property” (Jan. 12, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20028#ut0a-ch18"
    }
  }, [_vm._v("18. US Senate, Debate, Freedmen’s Bureau Bill (Jan. 19, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20029#ut0a-ch19"
    }
  }, [_vm._v("19. Joint Committee, Proposed Amendments, Vote on Apportionment Amendment (Jan. 20, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p3"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20030#ut0a-ch20"
    }
  }, [_vm._v("20. US House, Debate, Apportionment Amendment (Jan. 22, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20031#ut0a-ch21"
    }
  }, [_vm._v("21. US House, Debate, Apportionment Amendment, Women’s Suffrage Petition (Jan. 23, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20032#ut0a-ch22"
    }
  }, [_vm._v("22. US House, Debate, Apportionment Amendment (Jan. 24, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20033#ut0a-ch23"
    }
  }, [_vm._v("23. US House, Debate, Apportionment Amendment, Speech of John Bingham (Jan. 25, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20034#ut0a-ch24"
    }
  }, [_vm._v("24. US House, Debate, Apportionment Amendment, Speech of William Wright (D-NJ) (Jan. 26, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20035#ut0a-ch25"
    }
  }, [_vm._v("25. Joint Committee, John Bingham, Proposed Amendment Granting Congress Power to Enforce the Rights of Citizens and All Persons (Jan. 27, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20036#ut0a-ch26"
    }
  }, [_vm._v("26. US Senate, Debate, Civil Rights Bill, Proposed Addition of Citizenship Clause (Jan. 29, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20037#ut0a-ch27"
    }
  }, [_vm._v("27. US Senate, Debate, Civil Rights Bill, Amended Citizenship Clause (Jan. 30, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20038#ut0a-ch28"
    }
  }, [_vm._v("28. US House, Proposed Apportionment Amendment Referred Back to Joint Committee (Jan. 30, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20039#ut0a-ch29"
    }
  }, [_vm._v("29. US House, Apportionment Amendment, Speech of Thaddeus Stevens, Vote and Passage (Jan. 31, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20040#ut0a-ch30"
    }
  }, [_vm._v("30. US House, Freedmen’s Bureau Bill, Adding “the Constitutional Right to Bear Arms” (Feb. 1, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20041#ut0a-ch31"
    }
  }, [_vm._v("31. US Senate, Civil Rights Bill, Debate, Vote, and Passage (Feb. 2, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20042#ut0a-ch32"
    }
  }, [_vm._v("32. US House, Freedmen’s Bureau Bill, Debate and Passage (Feb. 2, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20043#ut0a-ch33"
    }
  }, [_vm._v("33. Joint Committee, John Bingham, Proposed Amendment Granting Power to Secure the Rights “of Citizens in the Several States” and “to All Persons in the Several States Equal Protection in the Rights of Life, Liberty and Property” (Feb. 3, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20044#ut0a-ch34"
    }
  }, [_vm._v("34. US Senate, Apportionment Amendment, Speech of Charles Sumner (Feb. 6, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20045#ut0a-ch35"
    }
  }, [_vm._v("35. US Senate, Apportionment Amendment, Remarks of William Pitt Fessenden (Feb. 7, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20046#ut0a-ch36"
    }
  }, [_vm._v("36. Joint Committee, Adoption of John Bingham’s Version of Proposed Amendment (Feb. 10, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20047#ut0a-ch37"
    }
  }, [_vm._v("37. US Senate, William Pitt Fessenden Reports Proposed Amendment (Feb. 13, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20048#ut0a-ch38"
    }
  }, [_vm._v("38. US Senate, Freedmen’s Bureau Bill, President Andrew Johnson’s Veto Message (Feb. 19, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20049#ut0a-ch39"
    }
  }, [_vm._v("39. US Senate, Freedmen’s Bureau Bill, Speech of Lyman Trumbull, Vote to Override Fails (Feb. 20, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20050#ut0a-ch40"
    }
  }, [_vm._v("40. US House, John Bingham Reports Proposed "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "4",
      "id": "p4",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Amendment Empowering Congress to Secure the “Privileges and Immunities” of Citizens and the Due Process Rights of All Persons, Response by Andrew Rogers (Feb. 26, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20051#ut0a-ch41"
    }
  }, [_vm._v("41. US House, Debate, Proposed Amendment Empowering Congress to Secure the “Privileges and Immunities” of Citizens and the Due Process Rights of All Persons (Feb. 27, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20052#ut0a-ch42"
    }
  }, [_vm._v("42. US House, Debate Continued, “Privileges and Immunities” Amendment, Speeches of John Bingham and Giles Hotchkiss, Vote to Postpone Consideration (Feb. 28, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20053#ut0a-ch43"
    }
  }, [_vm._v("43. US House, Debate, Civil Rights Bill, Speeches of James Wilson and M. Russell Thayer (Mar. 1–2, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20054#ut0a-ch44"
    }
  }, [_vm._v("44. US Senate, Debate, Apportionment Amendment, Opposition of Charles Sumner (Mar. 7, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20055#ut0a-ch45"
    }
  }, [_vm._v("45. US House, Debate, Civil Rights Bill (Mar. 8, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20056#ut0a-ch46"
    }
  }, [_vm._v("46. US House, Debate, Civil Rights Bill, Speech of Columbus Delano (R-OH) (Mar. 8, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20057#ut0a-ch47"
    }
  }, [_vm._v("47. US Senate, Debate, Apportionment Amendment, Fails Two-Thirds Vote (Mar. 9, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20058#ut0a-ch48"
    }
  }, [_vm._v("48. US House, Debate, Civil Rights Bill, Speech of John Bingham in Opposition (Mar. 9, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20059#ut0a-ch49"
    }
  }, [_vm._v("49. US House, Debate, Civil Rights Bill, Vote and Passage (Mar. 13, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20060#ut0a-ch50"
    }
  }, [_vm._v("50. US Senate, Motion to Retroactively Exclude John Stockton (Mar. 22, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20061#ut0a-ch51"
    }
  }, [_vm._v("51. US Senate, President Andrew Johnson’s Message Accompanying Veto of the Civil Rights Bill (Mar. 27, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20062#ut0a-ch52"
    }
  }, [_vm._v("52. US Senate, Exclusion of John Stockton (Mar. 27, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20063#ut0a-ch53"
    }
  }, [_vm._v("53. US Senate, Civil Rights Bill, Veto Override (Apr. 6, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20064#ut0a-ch54"
    }
  }, [_vm._v("54. US House, Civil Rights Bill, Speech of William Lawrence, Veto Override (Apr. 7, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20065#ut0a-ch55"
    }
  }, [_vm._v("55. S. S. Nicholas, “The Civil Rights Bill” (Apr. 12, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20066#ut0a-ch56"
    }
  }, [_vm._v("56. “News of Proposed Amendments in the Joint Committee on Reconstruction,” "), _c('i', [_vm._v("Chicago Tribune")]), _vm._v(" (Apr. 16, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20067#ut0a-ch57"
    }
  }, [_vm._v("57. Joint Committee, Thaddeus Stevens Introduces Five-Section Constitutional Amendment (Apr. 21, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20068#ut0a-ch58"
    }
  }, [_vm._v("58. Joint Committee, Proposed Constitutional Amendment (Apr. 25, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20069#ut0a-ch59"
    }
  }, [_vm._v("59. Joint Committee, Proposed Constitutional "), _c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "p4"
    }
  }), _vm._v("Amendment, Adoption of John Bingham’s Draft of Section One (Apr. 28, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20070#ut0a-ch60"
    }
  }, [_vm._v("60. US House, Thaddeus Stevens Introduces Proposed Five-Section Fourteenth Amendment (Apr. 30, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20071#ut0a-ch61"
    }
  }, [_vm._v("61. “The Progress of Reconstruction—What the ‘Secret Directory’ Proposes,” "), _c('i', [_vm._v("New York Times")]), _vm._v(" (Apr. 30, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20072#ut0a-ch62"
    }
  }, [_vm._v("62. US House, Proposed Fourteenth Amendment, Speech of Thaddeus Stevens Introducing the Amendment, Debate (May 8, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20073#ut0a-ch63"
    }
  }, [_vm._v("63. US House, Proposed Fourteenth Amendment, Debate and Passage (May 10, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20074#ut0a-ch64"
    }
  }, [_vm._v("64. US Senate, Proposed Fourteenth Amendment, Speech of Jacob Howard Introducing the Amendment (May 23, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20075#ut0a-ch65"
    }
  }, [_vm._v("65. “The Reconstruction Debate in the Senate, Mr. Howard Speaks on Behalf of the Committee,” "), _c('i', [_vm._v("New York Times")]), _vm._v(" (May 24, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20076#ut0a-ch66"
    }
  }, [_vm._v("66. US Senate, Proposed Fourteenth Amendment, Debate, Citizenship Clause Added, Section Three Removed and Replaced, Alterations to Section Four (May 29, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20077#ut0a-ch67"
    }
  }, [_vm._v("67. US Senate, Proposed Fourteenth Amendment, Debate (May 30, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20078#ut0a-ch68"
    }
  }, [_vm._v("68. US Senate, Proposed Fourteenth Amendment, Debate Continued (May 31, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20079#ut0a-ch69"
    }
  }, [_vm._v("69. US Senate, Proposed Fourteenth Amendment, Debate Continued (June 4, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20080#ut0a-ch70"
    }
  }, [_vm._v("70. US Senate, Proposed Fourteenth Amendment, Debate Continued, Speech of Luke Poland, Remarks of William M. Stewart (June 5, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20081#ut0a-ch71"
    }
  }, [_vm._v("71. US Senate, Proposed Fourteenth Amendment, Speech of Garrett Davis (June 7, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20082#ut0a-ch72"
    }
  }, [_vm._v("72. US Senate, Proposed Fourteenth Amendment, Debate, Passage of Amended Version (June 8, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20083#ut0a-ch73"
    }
  }, [_vm._v("73. Majority and Minority Reports of the Joint Committee (June 8, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20084#ut0a-ch74"
    }
  }, [_vm._v("74. US House, Proposed Fourteenth Amendment, Speech of Thaddeus Stevens, Vote and Passage of Amended Senate Version (June 13, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20085#ut0a-ch75"
    }
  }, [_vm._v("75. US House, Proposed Fourteenth Amendment, Discussion Regarding Presentment to the President for Signature (June 15, 1866)")])]), _vm._v(" "), _c('p', {
    staticClass: "ctoc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20086#ut0a-ch76"
    }
  }, [_vm._v("76. US Senate, Proposed Fourteenth Amendment, President Andrew Johnson’s Message of Transmission (June 22, 1866)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2821131c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lash-vol2-0008.vue
// module id = 75
// module chunks = 0